import { render, staticRenderFns } from "./IncidentDetail.vue?vue&type=template&id=2e0163bf&scoped=true&"
import script from "./IncidentDetail.vue?vue&type=script&lang=js&"
export * from "./IncidentDetail.vue?vue&type=script&lang=js&"
import style0 from "./IncidentDetail.vue?vue&type=style&index=0&id=2e0163bf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0163bf",
  null
  
)

export default component.exports